import { track } from '@hbf/analytics';

export const setRemarketingTag = (
  tags,
  { nonInteraction } = { nonInteraction: 1 },
) => {
  track('User tagged for remarketing', { ...tags, nonInteraction });
};
